import { render, staticRenderFns } from "./MemberListHomeLayout.vue?vue&type=template&id=4050e710&scoped=true&"
import script from "./MemberListHomeLayout.vue?vue&type=script&lang=js&"
export * from "./MemberListHomeLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4050e710",
  null
  
)

export default component.exports